import { Box } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const Container = styled(Box)`
  div {
    flex-shrink: 1;
  }
`

export const LegendColor = styled(Box)`
  height: 12px;
  width: 12px;
  border-radius: 50%;
`
